import { push } from 'connected-react-router';
import * as Auth from '../helpers/authService';
import {
	itemsIsLoading,
	receiveSuccessAlert,
	receiveErrorAlert,
	closeAlert
} from './commonsActions';
/*
 * action types
 */
import { fetchCompanies } from './companyActions';
import {FETCH_COMPANIES_STATS_ERROR} from "./statsActions";

export const IS_LOGGED_IN = 'IS_LOGGED_IN';
export const GET_USER_DATA = 'GET_USER_DATA';


/*
 * action creators
 */

export const isAuth = bool => ({
	type: IS_LOGGED_IN,
	isAuth: bool
});

export const getUserData = () => {
	//const companies = dispatch(fetchCompanies());
	//console.log('COMPANIES', companies);
	const user = Auth.getProfile();
	return ({
		type: GET_USER_DATA,
		user: user
	});
};

export const userLogout = () => dispatch => {
	Auth.logout();
	dispatch(isAuth(false));
};

export const checkAutorization = () => dispatch => {
	console.log('loggedIn');
	dispatch(itemsIsLoading(true));
	return Auth.loggedIn()
		.then(async res => {
			if (res) {
				console.log('auth res true', res)
				try {
					await dispatch(fetchCompanies());
					await dispatch(getUserData());
					await dispatch(isAuth(true));
				} catch (err) {
					console.error('auth res false', err);
					dispatch(isAuth(false));
					dispatch(push('/'));
				}
			} else {
				console.log('auth res false')
				dispatch(isAuth(false));
				dispatch(push('/'));
			}
			dispatch(itemsIsLoading(false));
			return res;
		})
};

export const userLogin = (credentials) => dispatch => {
	return Auth.login(credentials.username, credentials.password)
		.then(async res => {
			Auth.setToken(res.accessToken, res.refreshToken); // Setting the token in localStorage
			try {
				await dispatch(fetchCompanies());
				await dispatch(getUserData());
				await dispatch(isAuth(true));
				return res
			} catch (err) {
				console.error(err);
				dispatch(isAuth(false));
				dispatch(receiveErrorAlert(err));
				setTimeout(() => {
					dispatch(closeAlert());
				}, 2000);
			}
		}, error => {
			console.error(error);
			dispatch(isAuth(false));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
};

export const userRegistration = credentials => dispatch => {
	return Auth.signup(credentials.username, credentials.password)
		.then(res => {
			console.log('success registration');
			dispatch(receiveSuccessAlert('Check your email to confirm registration.'));
			return res;
		}, error => {
			console.error('error registration');
			dispatch(receiveErrorAlert(error));
			return error;
		})
};

export const userConfirmation = token => dispatch => {
	return Auth.confirmate(token)
		.then(res => {
			console.log('success confirmation');
			dispatch(receiveSuccessAlert('success confirmation'));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 3000);
			return res;
		}, error => {
			console.error('error registration');
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 3000);
			return error;
		})
};

export const passwdRecover = email => dispatch => {
	return Auth.recover(email)
		.then(res => {
			console.log('send recover email');
			dispatch(receiveSuccessAlert('Check your email for the next step'));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 3000);
			return res;
		}, error => {
			console.error('send recover email');
			dispatch(receiveErrorAlert(error));
			return error;
		});
};

export const updatePasswd = credentials => dispatch => {
	return Auth.passwdUpdate(credentials)
		.then(res => {
			console.log('update passwd');
			dispatch(receiveSuccessAlert('Password updated.'));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 3000);
			return res;
		}, error => {
			console.error('update passwd');
			dispatch(receiveErrorAlert(error));
			return error;
		});
};

export const resetPasswd = credentials => dispatch => {
    return Auth.resetPassword(credentials)
        .then(res => {
            console.log('reset passwd');
            dispatch(receiveSuccessAlert('Password reseted.'));
            setTimeout(() => {
                dispatch(closeAlert());
            }, 3000);
            return res;
        }, error => {
            console.error('reset passwd');
            dispatch(receiveErrorAlert(error));
            return error;
        });
};

export const checkExistingLogin = login => dispatch => {
	return Auth.checkLogin(login)
		.then(res => {
			console.log('success');
			dispatch(receiveSuccessAlert(res));
			return res;
		}, error => {
			console.error(error);
			console.error('User already exist');
			dispatch(receiveErrorAlert('User already exist'));
			throw new Error('user already exist');
		})
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js